import request from "@/app/api/request";
import {
  CourtBigModel,
  CourtCreateRequestModel,
  CourtModel,
  CourtRequestModel,
  CourtsRequestModel, CourtUpdateStatusRequestModel
} from "@/app/api/courts/models";

export class CourtsRequests {
  static async getCourts(model: CourtsRequestModel): Promise<CourtModel[]> {
    try {
      return await request.get<CourtModel[]>('/courts/nearbyCourts', {query: model});
    } catch (error: any) {
      throw error;
    }
  }

  static async getCourt(model: CourtRequestModel): Promise<CourtBigModel> {
    try {
      return await request.get<CourtBigModel>('/courts/getCourt', {query: model});
    } catch (error: any) {
      throw error;
    }
  }

  static async createCourt(data: CourtCreateRequestModel): Promise<CourtBigModel> {
    try {
      return await request.post<CourtBigModel>('/courts/createDraftCourt', {data});
    } catch (error: any) {
      throw error;
    }
  }

  static async getDraftCourts(): Promise<CourtBigModel[]> {
    try {
      return await request.get<CourtBigModel[]>('/courts/getDraftCourts', {});
    } catch (error: any) {
      throw error;
    }
  }

  static async updateDraftCourtStatus(query: CourtUpdateStatusRequestModel): Promise<boolean> {
    try {
      return await request.post<boolean>('/courts/updateDraftCourtStatus', {query});
    } catch (error: any) {
      throw error;
    }
  }
}

